import { render, staticRenderFns } from "./FullNameInputs.vue?vue&type=template&id=23e5843c&scoped=true&"
import script from "./FullNameInputs.vue?vue&type=script&lang=js&"
export * from "./FullNameInputs.vue?vue&type=script&lang=js&"
import style0 from "./FullNameInputs.vue?vue&type=style&index=0&id=23e5843c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e5843c",
  null
  
)

export default component.exports